export const SCROLL_RESTORATION_IGNORED_CLASSES = [
	'preview-exercise-aside__bottom',
	'support-chat-scroll',
]
